export default __webpack_public_path__ + "static/mobile-bg-feature-5a0f0e0ed55d655a2f167535ed5b2c2d.png";